module.exports = __webpack_public_path__ + "media/images/subject_img/MEDICINE-125e5d1e03754c20c7459440653a5dac.jpg";